/**
 * The employee guide to what Claire can do, shown from the info button in her chats and FIN chat.
 * The content lives with the Cloud Functions so Claire reads the same guide; edit it there (see AGENTS.md).
 */

export const CLAIRE_FIN_EMAIL = 'claire@chorostandco.com';
export const isClaireEmail = (email?: string | null) => (email || '').toLowerCase() === CLAIRE_FIN_EMAIL;

export { GUIDE_INTRO, GUIDE_SECTIONS } from '../../../functions/src/claire/guideContent';
export type { GuideSection } from '../../../functions/src/claire/guideContent';
